// Map of Permissions to meeting folder

import { PermissionEnum } from '@orgbrain/roles';

import { ALLOW_READ, ALLOW_READ_WRITE, FORBID_READ_WRITE } from './classes';
import { FileFolderEnum } from './lib-files';

import { ACLPrivileges, MeetingType } from '@orgbrain/lib-data';

// How this file permission maginc works:
// First: you define a group in libs/roles/src/lib/rolesAndPermissions.ts
// Then you create a below object. The "magic" will take the group name from that file and map it into folder permission
// Final step: add control tables: export const newsDataPrivileges: ControlTables = {acl: [adminFull, adminFullNews, adminFullNewsGA, boardRead, buyerRead, shareRead]
const adminFullNews: { [permission: string]: ACLPrivileges } = {};
adminFullNews[PermissionEnum.NEWS_ADMIN] = ALLOW_READ_WRITE;
const adminFullNewsGA: { [permission: string]: ACLPrivileges } = {};
adminFullNewsGA[PermissionEnum.GA_NEWS_ADMIN] = ALLOW_READ_WRITE;
const newsReadAccessShareholder: { [permission: string]: ACLPrivileges } = {};
newsReadAccessShareholder[PermissionEnum.ACCESS_TO_NEWS_FOR_SHAREHOLDERS] = ALLOW_READ;
const newsReadAccessBoard: { [permission: string]: ACLPrivileges } = {};
newsReadAccessBoard[PermissionEnum.ACCESS_TO_NEWS_FOR_BOARD] = ALLOW_READ;

const buyerRead: { [permission: string]: ACLPrivileges } = {};
buyerRead[PermissionEnum.BUYER] = ALLOW_READ;

const boardRead: { [permission: string]: ACLPrivileges } = {};
boardRead[PermissionEnum.ACCESS_TO_BOARD_MEETINGS] = ALLOW_READ;

const shareRead = {};
shareRead[PermissionEnum.ACCESS_TO_GA_MEETINGS] = ALLOW_READ;

const adminRead: { [permission: string]: ACLPrivileges } = {};
adminRead[PermissionEnum.ADMIN] = ALLOW_READ;

const meetingadminRead: { [permission: string]: ACLPrivileges } = {};
meetingadminRead[PermissionEnum.MEETING_ADMIN] = ALLOW_READ;

const adminFull: { [permission: string]: ACLPrivileges } = {};
adminFull[PermissionEnum.ADMIN] = ALLOW_READ_WRITE;

const taskAdminFull: { [permission: string]: ACLPrivileges } = {};
taskAdminFull[PermissionEnum.TASKS_ADMIN] = ALLOW_READ_WRITE;

const tasksRead: { [permission: string]: ACLPrivileges } = {};
tasksRead[PermissionEnum.tasks] = ALLOW_READ_WRITE;

const meetingadminFull: { [permission: string]: ACLPrivileges } = {};
meetingadminFull[PermissionEnum.MEETING_ADMIN] = ALLOW_READ_WRITE;

const buyerExclude: { [permission: string]: ACLPrivileges } = {};
buyerExclude[PermissionEnum.BUYER] = FORBID_READ_WRITE;

const ddACLArray: { [permission: string]: ACLPrivileges }[] = [
  { [PermissionEnum.ADMIN]: ALLOW_READ_WRITE },
  { [PermissionEnum.BUYER]: ALLOW_READ },
  { [PermissionEnum.SELLER]: ALLOW_READ_WRITE },
  { [PermissionEnum.SELLER_ADMIN]: ALLOW_READ_WRITE },
  { [PermissionEnum.BUYER_ADMIN]: ALLOW_READ },
];

export class ControlTables {
  acl?: { [permission: string]: ACLPrivileges }[];
  ecl?: { [permission: string]: ACLPrivileges }[];
}

export class PrivilegeTable {
  [type: string]: ControlTables;
}

/**
 *
 * VisibleToAll Folder
 * Used for VisibleToAll folder and Shared Folder with full access
 *
 */
export const VISIBLE_TO_ALL_BASE_FOLDER_NAME = 'VisibleToAll';
export const visibleToAllDataPrivileges: ControlTables = {
  acl: [adminFull, boardRead, buyerRead, shareRead],
};

/**
 *
 * News Data Folder
 * "Virtual" folder, it is not listed in FilebrowserNavigator but is used for creating News Attachments
 *
 */
export const NEWS_BASE_FOLDER_NAME = 'DataNews';
export const newsDataPrivileges: ControlTables = {
  acl: [adminFull, adminFullNews, adminFullNewsGA, boardRead, buyerRead, shareRead],
};
export const publicNews: ControlTables = {
  acl: [adminFullNews, adminFullNewsGA, newsReadAccessBoard, newsReadAccessShareholder],
};
export const boardNews: ControlTables = {
  acl: [adminFullNews, newsReadAccessBoard],
};
/*
 * Proxy Data Folder
 * "Virtual" folder, it is not listed in FilebrowserNavigator but is used for creating News Attachments
 *
 */
export const PROXY_BASE_FOLDER_NAME = 'DataProxy';
export const proxyDataPrivileges: ControlTables = {
  acl: [adminFull, meetingadminFull, boardRead, buyerRead, shareRead],
};

/**
 *
 * Beneficial Owners folder
 * Virtual" folder, it is not listed in FilebrowserNavigator but is used for creating beneficial owners attachements
 */
export const BENEFICIAL_OWNERS_FOLDER_NAME = 'BeneficialOwners';
export const beneficialOwnersDataPrivileges: ControlTables = {
  acl: [adminFull, boardRead, buyerRead, shareRead],
};

export const OPTION_FOLDER_NAME = 'Options';
export const optionDataPrivileges: ControlTables = {
  acl: [adminFull, boardRead, buyerRead, shareRead],
};

export const TASKS_FOLDER_NAME = 'Tasks';
export const tasksDataPrivileges: ControlTables = {
  acl: [adminFull, taskAdminFull, boardRead, buyerRead, shareRead, tasksRead],
};

export const CONVERSATIONS_FOLDER_NAME = 'Conversations';
export const conversationsDataPrivileges: ControlTables = {
  acl: [adminFull, taskAdminFull, boardRead, buyerRead, shareRead, tasksRead],
};

export const EMISSIONS_FOLDER_NAME = 'Emissions';
export const CLAIMS_FOLDER_NAME = 'Claims';

export const claimsDataPrivileges: ControlTables = {
  acl: [adminFull, boardRead, buyerRead, shareRead],
};

export const emissionsDataPrivileges: ControlTables = {
  acl: [adminFull, boardRead, buyerRead, shareRead],
};
/**
 *
 *  Data Room
 *  Used for Common Files folder and Shared Folder with restricted access
 *
 */
export const DATA_ROOM_NAME = 'DataRoom';
export const dataRoomPrivileges: ControlTables = {
  acl: [adminFull, boardRead],
};

export const ddPrivileges: ControlTables = {
  acl: ddACLArray,
};

/**
 *   Access to MEETIGNS ROOT FOLDER
 *
 */
export const meetingsPrivileges: ControlTables = {
  acl: [adminRead, buyerRead, boardRead, shareRead, meetingadminRead],
};

/**
 *    MEETING TYPE PERMISSIONS
 *
 */

export const meetingTypePrivileges: PrivilegeTable = {};

meetingTypePrivileges[MeetingType.BOARD_MEETING] = {
  acl: [adminRead, buyerRead, boardRead, meetingadminRead],
};

meetingTypePrivileges[MeetingType.OTHER_MEETING] = meetingTypePrivileges[MeetingType.BOARD_MEETING];

meetingTypePrivileges[MeetingType.ANNUAL_GENERAL_MEETING] = {
  acl: [adminRead, buyerRead, boardRead, shareRead, meetingadminRead],
};

meetingTypePrivileges[MeetingType.EXTRAORDINARY_GENERAL_MEETING] =
  meetingTypePrivileges[MeetingType.ANNUAL_GENERAL_MEETING];

meetingTypePrivileges[MeetingType.SHAREHOLDER_MEETING] =
  meetingTypePrivileges[MeetingType.ANNUAL_GENERAL_MEETING];

//   MEETING LAYER  (Draft)

export const meetingPrivilegesDraft: PrivilegeTable = {};

meetingPrivilegesDraft[MeetingType.BOARD_MEETING] = {
  acl: [adminFull, meetingadminFull],
};

meetingPrivilegesDraft[MeetingType.OTHER_MEETING] =
  meetingPrivilegesDraft[MeetingType.BOARD_MEETING];

meetingPrivilegesDraft[MeetingType.ANNUAL_GENERAL_MEETING] =
  meetingPrivilegesDraft[MeetingType.BOARD_MEETING];

meetingPrivilegesDraft[MeetingType.EXTRAORDINARY_GENERAL_MEETING] =
  meetingPrivilegesDraft[MeetingType.ANNUAL_GENERAL_MEETING];

meetingPrivilegesDraft[MeetingType.SHAREHOLDER_MEETING] =
  meetingPrivilegesDraft[MeetingType.ANNUAL_GENERAL_MEETING];

//   MEETING LAYER  (Draft)

export const meetingPrivilegesPublished: PrivilegeTable = {};

meetingPrivilegesPublished[MeetingType.BOARD_MEETING] = {
  acl: [adminFull, meetingadminFull, boardRead, buyerRead],
};

meetingPrivilegesPublished[MeetingType.OTHER_MEETING] =
  meetingPrivilegesPublished[MeetingType.BOARD_MEETING];

meetingPrivilegesPublished[MeetingType.ANNUAL_GENERAL_MEETING] = {
  acl: [adminFull, meetingadminFull, boardRead, buyerRead, shareRead],
};

meetingPrivilegesPublished[MeetingType.EXTRAORDINARY_GENERAL_MEETING] =
  meetingPrivilegesPublished[MeetingType.ANNUAL_GENERAL_MEETING];

meetingPrivilegesPublished[MeetingType.SHAREHOLDER_MEETING] =
  meetingPrivilegesPublished[MeetingType.ANNUAL_GENERAL_MEETING];

// Subfolder Layer

export const meetingPrivilegesSubFolder: { [type: string]: PrivilegeTable } = {};

meetingPrivilegesSubFolder[MeetingType.BOARD_MEETING] = {};

meetingPrivilegesSubFolder[MeetingType.BOARD_MEETING][FileFolderEnum.ATTACHMENTS] = {
  ecl: [buyerExclude],
};

meetingPrivilegesSubFolder[MeetingType.OTHER_MEETING] = {};
meetingPrivilegesSubFolder[MeetingType.OTHER_MEETING][FileFolderEnum.ATTACHMENTS] =
  meetingPrivilegesSubFolder[MeetingType.BOARD_MEETING][FileFolderEnum.ATTACHMENTS];

meetingPrivilegesSubFolder[MeetingType.ANNUAL_GENERAL_MEETING] = {};
meetingPrivilegesSubFolder[MeetingType.ANNUAL_GENERAL_MEETING][FileFolderEnum.ATTACHMENTS] =
  meetingPrivilegesSubFolder[MeetingType.BOARD_MEETING][FileFolderEnum.ATTACHMENTS];

meetingPrivilegesSubFolder[MeetingType.EXTRAORDINARY_GENERAL_MEETING] = {};
meetingPrivilegesSubFolder[MeetingType.EXTRAORDINARY_GENERAL_MEETING][FileFolderEnum.ATTACHMENTS] =
  meetingPrivilegesSubFolder[MeetingType.BOARD_MEETING][FileFolderEnum.ATTACHMENTS];

meetingPrivilegesSubFolder[MeetingType.SHAREHOLDER_MEETING] = {};
meetingPrivilegesSubFolder[MeetingType.SHAREHOLDER_MEETING][FileFolderEnum.ATTACHMENTS] =
  meetingPrivilegesSubFolder[MeetingType.BOARD_MEETING][FileFolderEnum.ATTACHMENTS];
